// extracted by mini-css-extract-plugin
export default {"dialog":"Q1u3p3p1ZjoY7Zlg","subHeader":"YDXiIp9vacbEeYjf","body":"jcUYMDmNrgfJdzqI"};